import { API } from './api'

export interface OrderItem {
  orderNo: string
  articleId: string
  quantity: number
  lineNo: string
}

export const fetchOrderItemsByOrderNumber = (orderNo: string): Promise<OrderItem[]> => {
  return API.get('its-orders', '/order-items', {
    queryStringParameters: { orderNo },
  })
}
